<div class="page" size="A4">
  <div class="report-form-full-column">
    <div class="report-form-barcode">
      {{ pii.kitId }}
    </div>
    @if (simpleCode) {
      <div class="report-form-simple-code">{{ simpleCode }}</div>
    }
  </div>
  <div style="clear: both"></div>
  <div class="report-form-full-column">
    <div class="report-form-header">
      {{ chapterTitles['patientInformation'] }}
    </div>
    <div class="report-form-region">
      <div class="report-form-inner-left-column">
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.patientName' | translate }}
          </div>
          <div class="report-form-value">
            {{ anonymizeName(getFullName(serviceData)) }}
          </div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.dateOfBirth' | translate }}
          </div>
          <div class="report-form-value">
            {{
              moment(
                getDateOnly(
                  pii.sample.serviceData.patientInformation?.dateOfBirth
                )
              ).format(MOMENT_DATE_FORMAT)
            }}
          </div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.weight' | translate }}
          </div>
          <div class="report-form-value">
            {{ serviceData.patientInformation?.weight }} kg
          </div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.height' | translate }}
          </div>
          <div class="report-form-value">
            {{ serviceData.patientInformation?.height }} cm
          </div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.bmiOver40' | translate }}
          </div>
          <div class="report-form-value">
            {{
              (patientBMI$ | async)
                ? ('pdfRequestForm.common.yesUpper' | translate)
                : ('pdfRequestForm.common.noUpper' | translate)
            }}
          </div>
        </div>
        @if (fieldSet.includes(ServiceDataFields.PatientGender)) {
          <div class="report-form-row">
            <div class="report-form-key">
              {{ 'pdfRequestForm.fields.gender' | translate }}
            </div>
            <div class="report-form-value">
              {{ serviceData.serviceInformation.shared.patientGender }}
            </div>
          </div>
        }
        @if (fieldSet.includes(ServiceDataFields.Ethnicity)) {
          <div class="report-form-row">
            <div class="report-form-key">
              {{ 'pdfRequestForm.fields.ethnicity' | translate }}
            </div>
            <div class="report-form-value">
              {{
                serviceData.serviceInformation.shared.patientInformation
                  ?.ethnicity
              }}
            </div>
          </div>
        }
      </div>
      <div style="clear: both"></div>
    </div>
  </div>

  @if (fieldSet.includes(ServiceDataFields.PregnancyInformation)) {
    <div class="report-form-full-column">
      <div class="report-form-header">
        {{ chapterTitles['currentPregnancy'] }}
      </div>
      <div class="report-form-region">
        <div class="report-form-inner-left-column">
          @if (fieldSet.includes(ServiceDataFields.PregnancyStatus)) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{ 'pdfRequestForm.fields.currentlyPregnant' | translate }}
              </div>
              <div class="report-form-value">
                @if (
                  serviceData.serviceInformation.galleri
                    ?.currentPregnancyInformation?.isPregnant
                ) {
                  <ng-container *ngTemplateOutlet="yesChoice" />
                } @else {
                  <ng-container *ngTemplateOutlet="noChoice" />
                }
              </div>
            </div>
          }
          @if (
            serviceData.serviceInformation.shared?.currentPregnancyInformation;
            as pregnancyInformation
          ) {
            @if (fieldSet.includes(ServiceDataFields.DueDate)) {
              <div class="report-form-row">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.expectedBirthDate' | translate }}
                </div>
                <div class="report-form-value">
                  {{
                    moment(
                      pregnancyInformation?.expectedConfinementDate
                    ).format(MOMENT_DATE_FORMAT)
                  }}
                </div>
              </div>
              <div class="report-form-row">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.gestationalAgeAtDraw' | translate }}
                </div>
                <div class="report-form-value">
                  {{ pregnancyInformation?.gestationAge?.week }}
                  {{ 'pdfRequestForm.common.weeks' | translate }}
                  {{ pregnancyInformation?.gestationAge?.day }}
                  {{ 'pdfRequestForm.common.days' | translate }}
                </div>
              </div>
            }
            @if (fieldSet.includes(ServiceDataFields.PregnancyType)) {
              <div class="report-form-row">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.numberOfFetuses' | translate }}
                </div>
                <div class="report-form-value">
                  @if (
                    pregnancyInformation?.pregnancyType ===
                    PregnancyType.singleton
                  ) {
                    1
                  }
                  @if (
                    pregnancyInformation?.pregnancyType === PregnancyType.twins
                  ) {
                    2
                  }
                </div>
              </div>
            }
            @if (fieldSet.includes(ServiceDataFields.Ivf)) {
              <div class="report-form-row">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.ivf' | translate }}
                </div>
                <div class="report-form-value">
                  @if (pregnancyInformation?.inVitro?.isInVitroFertilized) {
                    {{ 'pdfRequestForm.common.yes' | translate }},
                    {{ pregnancyInformation?.inVitro?.vitroType }}
                  }
                  @if (!pregnancyInformation?.inVitro?.isInVitroFertilized) {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-row">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.vanishingTwinSyndrome' | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (
                    pregnancyInformation?.vanishingTwinSyndrome?.isDetected
                  ) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-row">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.surrogateMother' | translate }}
                </div>
                <div class="report-form-value">
                  @if (pregnancyInformation?.inVitro?.isSurrogateMother) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
            }

            @if (fieldSet.includes(ServiceDataFields.HeparinTherapy)) {
              <div class="report-form-row">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.heparinTherapy' | translate }}
                </div>
                <div class="report-form-value">
                  @if (
                    pregnancyInformation?.heparinTherapy?.hasReceived &&
                    !pregnancyInformation?.heparinTherapy?.isRelevant
                  ) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
            }
            @if (fieldSet.includes(ServiceDataFields.DateOfUltrasound)) {
              <div class="report-form-row" style="padding-top: 5px">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.dateOfLastUltrasound' | translate }}
                </div>
                <div class="report-form-value">
                  @if (pregnancyInformation?.ultrasoundDate) {
                    {{
                      moment(pregnancyInformation?.ultrasoundDate).format(
                        MOMENT_DATE_FORMAT
                      )
                    }}
                  } @else {
                    {{ 'pdfRequestForm.common.noDataEntered' | translate }}
                  }
                </div>
              </div>
            }
          }
          @if (
            serviceData.serviceInformation.nipt?.currentPregnancyInformation;
            as pregnancyInformation
          ) {
            @if (fieldSet.includes(ServiceDataFields.PriorScreeningTest)) {
              <div class="report-form-row">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.priorScreeningTest' | translate }}
                </div>
                <div class="report-form-value">
                  {{
                    pregnancyInformation?.priorScreeningTest
                      ?.priorScreeningTestType
                  }}
                </div>
              </div>

              @if (
                pregnancyInformation?.priorScreeningTest
                  ?.priorScreeningTestType !==
                PriorScreeningTestType.NoTestTaken
              ) {
                <div class="report-form-row">
                  <div class="report-form-key">
                    {{ 'pdfRequestForm.fields.t21Risk' | translate }}
                  </div>
                  <div class="report-form-value">
                    1/{{
                      pregnancyInformation?.priorScreeningTest?.firstTRisks
                        ?.t21Risk
                    }}
                  </div>
                </div>
                <!--$T18RiskVisibility-->
                <div class="report-form-row">
                  <div class="report-form-key">
                    {{ 'pdfRequestForm.fields.t18Risk' | translate }}
                  </div>
                  <div class="report-form-value">
                    1/{{
                      pregnancyInformation?.priorScreeningTest?.firstTRisks
                        ?.t18Risk
                    }}
                  </div>
                </div>
                <!--$T13RiskVisibility-->
                <div class="report-form-row">
                  <div class="report-form-key">
                    {{ 'pdfRequestForm.fields.t13Risk' | translate }}
                  </div>
                  <div class="report-form-value">
                    1/{{
                      pregnancyInformation?.priorScreeningTest?.firstTRisks
                        ?.t13Risk
                    }}
                  </div>
                </div>
              }
            }
          }
        </div>
        <div class="report-form-inner-right-column">
          @if (
            serviceData.serviceInformation.shared?.currentPregnancyInformation;
            as pregnancyInformation
          ) {
            @if (fieldSet.includes(ServiceDataFields.DueDate)) {
              <div class="report-form-row">
                <div class="report-form-key">&nbsp;</div>
                <div class="report-form-value">&nbsp;</div>
              </div>
              <div class="report-form-row">
                <div class="report-form-key">&nbsp;</div>
                <div class="report-form-value">&nbsp;</div>
              </div>
            }
            @if (fieldSet.includes(ServiceDataFields.PregnancyType)) {
              @if (pregnancyInformation?.chorionicityType) {
                <div class="report-form-row">
                  <div class="report-form-key">
                    {{ 'pdfRequestForm.fields.chorionicity' | translate }}
                  </div>
                  <div class="report-form-value">
                    {{ pregnancyInformation?.chorionicityType }}
                  </div>
                </div>
              }
              @if (!pregnancyInformation?.chorionicityType) {
                <div class="report-form-row">
                  <div class="report-form-key">&nbsp;</div>
                  <div class="report-form-value">&nbsp;</div>
                </div>
              }
            }
            @if (fieldSet.includes(ServiceDataFields.Ivf)) {
              <div class="report-form-row">
                <div class="report-form-key">&nbsp;</div>
                <div class="report-form-value">&nbsp;</div>
              </div>
            }
            @if (fieldSet.includes(ServiceDataFields.VanishingTwinSyndrome)) {
              @switch (
                pregnancyInformation?.vanishingTwinSyndrome?.isDetected
              ) {
                @case (true) {
                  <div class="report-form-row">
                    <div class="report-form-key-wide">
                      {{
                        'pdfRequestForm.fields.detectedGestationalAge'
                          | translate
                      }}
                    </div>
                    <div class="report-form-value">
                      {{
                        pregnancyInformation?.vanishingTwinSyndrome
                          ?.detectedGestationAge?.week
                      }}
                      {{ 'pdfRequestForm.common.weeks' | translate }}
                      {{
                        pregnancyInformation?.vanishingTwinSyndrome
                          ?.detectedGestationAge?.day
                      }}
                      {{ 'pdfRequestForm.common.days' | translate }}
                    </div>
                  </div>
                }
                @default {
                  <div class="report-form-row">
                    <div class="report-form-key">&nbsp;</div>
                    <div class="report-form-value">&nbsp;</div>
                  </div>
                }
              }
            }
            @if (fieldSet.includes(ServiceDataFields.Ivf)) {
              <div class="report-form-row">
                <div class="report-form-key">&nbsp;</div>
                <div class="report-form-value">&nbsp;</div>
              </div>
            }
            @if (fieldSet.includes(ServiceDataFields.HeparinTherapy)) {
              <div class="report-form-row">
                <div class="report-form-key">&nbsp;</div>
                <div class="report-form-value">&nbsp;</div>
              </div>
            }
            <div class="report-form-row">
              <div class="report-form-key">&nbsp;</div>
              <div class="report-form-value">&nbsp;</div>
            </div>
            @if (fieldSet.includes(ServiceDataFields.DateOfUltrasound)) {
              <div class="report-form-row">
                <div class="report-form-key">&nbsp;</div>
                <div class="report-form-value">&nbsp;</div>
              </div>
            }
          }
          @if (
            serviceData.serviceInformation.nipt?.currentPregnancyInformation;
            as pregnancyInformation
          ) {
            @if (fieldSet.includes(ServiceDataFields.PriorScreeningTest)) {
              @if (
                pregnancyInformation?.pregnancyType === PregnancyType.twins &&
                pregnancyInformation?.priorScreeningTest
                  ?.priorScreeningTestType !==
                  PriorScreeningTestType.NoTestTaken
              ) {
                <!--$T212RiskVisibility-->
                <div class="report-form-row">
                  <div class="report-form-key">
                    {{ 'pdfRequestForm.fields.t21Risk' | translate }}
                  </div>
                  <div class="report-form-value">
                    2/{{
                      pregnancyInformation?.priorScreeningTest?.secondTRisks
                        ?.t21Risk
                    }}
                  </div>
                </div>
                <!--$T182RiskVisibility-->
                <div class="report-form-row">
                  <div class="report-form-key">
                    {{ 'pdfRequestForm.fields.t18Risk' | translate }}
                  </div>
                  <div class="report-form-value">
                    2/{{
                      pregnancyInformation?.priorScreeningTest?.secondTRisks
                        ?.t18Risk
                    }}
                  </div>
                </div>
                <!--$T132RiskVisibility-->
                <div class="report-form-row">
                  <div class="report-form-key">
                    {{ 'pdfRequestForm.fields.t13Risk' | translate }}
                  </div>
                  <div class="report-form-value">
                    2/{{
                      pregnancyInformation?.priorScreeningTest?.secondTRisks
                        ?.t13Risk
                    }}
                  </div>
                </div>
              }
            }
          }
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  }

  @if (fieldSet.includes(ServiceDataFields.PatientHistoryInformation)) {
    <div class="report-form-full-column">
      <div class="report-form-header">
        {{ chapterTitles['medicalData'] }}
      </div>
      <div class="report-form-region">
        @if (
          serviceData.serviceInformation.rhd?.patientHistory;
          as patientHistory
        ) {
          @if (fieldSet.includes(ServiceDataFields.RhdStatus)) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{ 'pdfRequestForm.fields.rhdStatus' | translate }}
              </div>
              <div class="report-form-value">
                @if (patientHistory?.rhdStatus?.status) {
                  <ng-container *ngTemplateOutlet="yesChoice" />
                } @else {
                  <ng-container *ngTemplateOutlet="noChoice" />
                }
              </div>
            </div>
          }
        }

        @if (
          serviceData.serviceInformation.carrier?.patientHistory;
          as patientHistory
        ) {
          @if (
            fieldSet.includes(ServiceDataFields.FamilyHistoryOfCysticFibrosis)
          ) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.familyHistoryOfCysticFibrosis'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.cysticFibrosisHistory.hasHistory) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.cysticFibrosisHistory.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.cysticFibrosisHistory?.diseases[0]
                          .conditionDescription
                      }}<br />
                      {{
                        'pdfRequestForm.common.relationToPatient' | translate
                      }}
                      {{
                        patientHistory?.cysticFibrosisHistory?.diseases[0]
                          .relationToPatient
                      }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }

        @if (
          serviceData.serviceInformation.cancerScreen?.patientHistory;
          as patientHistory
        ) {
          @if (fieldSet.includes(ServiceDataFields.DiseaseHistory)) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.patientHistoryOfDisease' | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.diseaseHistory.hasHistory) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.diseaseHistory?.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.diseaseHistory?.diseases[0]
                          .conditionDescription
                      }}
                      @if (
                        patientHistory?.diseaseHistory?.diseases[0]?.ageOfOnset
                      ) {
                        {{ 'pdfRequestForm.common.ageOfOnset' | translate }}
                        {{
                          patientHistory?.diseaseHistory?.diseases[0]
                            ?.ageOfOnset
                        }}
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (fieldSet.includes(ServiceDataFields.FamilyCancerHistory)) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.familyCancerHistory' | translate }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.familyCancerHistory.hasHistory) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.familyCancerHistory.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.familyCancerHistory?.diseases[0]
                          .conditionDescription
                      }}<br />
                      {{
                        'pdfRequestForm.common.relationToPatient' | translate
                      }}
                      {{
                        patientHistory?.familyCancerHistory?.diseases[0]
                          .relationToPatient
                      }}
                      @if (
                        patientHistory?.familyCancerHistory?.diseases[0]
                          ?.ageOfOnset
                      ) {
                        {{ 'pdfRequestForm.common.ageOfOnset' | translate }}
                        {{
                          patientHistory?.familyCancerHistory?.diseases[0]
                            ?.ageOfOnset
                        }}
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (fieldSet.includes(ServiceDataFields.KnownFamilyMutations)) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.knownFamilyMutations' | translate }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.knownFamilyMutations.hasHistory) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.knownFamilyMutations.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.knownFamilyMutations?.diseases[0]
                          .conditionDescription
                      }}<br />
                      {{
                        'pdfRequestForm.common.relationToPatient' | translate
                      }}
                      {{
                        patientHistory?.knownFamilyMutations?.diseases[0]
                          .relationToPatient
                      }}
                      @if (
                        patientHistory?.knownFamilyMutations?.diseases[0]
                          ?.ageOfOnset
                      ) {
                        {{ 'pdfRequestForm.common.ageOfOnset' | translate }}
                        {{
                          patientHistory?.knownFamilyMutations?.diseases[0]
                            ?.ageOfOnset
                        }}
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }

        @if (
          serviceData.serviceInformation.galleri?.patientHistory;
          as patientHistory
        ) {
          @if (
            fieldSet.includes(ServiceDataFields.CurrentlyDiagnosedWithCancer)
          ) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{
                  'pdfRequestForm.fields.currentlyDiagnosedWithCancer'
                    | translate
                }}
              </div>
              <div class="report-form-value">
                @if (patientHistory.currentlyDiagnosedWithCancer) {
                  <ng-container *ngTemplateOutlet="yesChoice" />
                } @else {
                  <ng-container *ngTemplateOutlet="noChoice" />
                }
              </div>
            </div>
          }
          @if (fieldSet.includes(ServiceDataFields.CancerSurvivor)) {
            <div class="report-form-row">
              <div class="report-form-inner-left-column">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.cancerSurvivor' | translate }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory.cancerSurvivor.isSurvivor) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              @if (patientHistory.cancerSurvivor.isSurvivor) {
                <div class="report-form-inner-right-column">
                  <div class="report-form-key">
                    {{
                      'pdfRequestForm.fields.cancerDiagnosisMoreThanThreeYearsAgo'
                        | translate
                    }}
                  </div>
                  <div class="report-form-value">
                    {{
                      (patientHistory.cancerSurvivor.moreThanThreeYearsAgo
                        ? 'pdfRequestForm.common.yes'
                        : 'pdfRequestForm.common.no'
                      ) | translate
                    }}
                  </div>
                </div>
              }
            </div>
          }
          @if (fieldSet.includes(ServiceDataFields.SolidOrganTransplant)) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{ 'pdfRequestForm.fields.solidOrganTransplant' | translate }}
              </div>
              <div class="report-form-value">
                @if (patientHistory.solidOrganTransplant.hasReceived) {
                  <ng-container *ngTemplateOutlet="yesChoice" />
                } @else {
                  <ng-container *ngTemplateOutlet="noChoice" />
                }
              </div>
            </div>
          }
          @if (fieldSet.includes(ServiceDataFields.CancerSuspicion)) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.cancerSuspicion' | translate }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory.cancerSuspicion.isSuspicious) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              @if (patientHistory.cancerSuspicion.isSuspicious) {
                <div class="report-form-row text-start">
                  {{ 'pdfRequestForm.fields.suspicionDescription' | translate }}
                  {{ patientHistory.cancerSuspicion.suspicionDescription }}
                </div>
              }
            </div>
          }
        }

        @if (
          serviceData.serviceInformation.venisafe?.patientHistory;
          as patientHistory
        ) {
          @if (fieldSet.includes(ServiceDataFields.CardiovascularConditions)) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.cardiovascularConditionsHistory'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.cardiovascularConditions.hasHistory) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.cardiovascularConditions.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.cardiovascularConditions?.diseases[0]
                          .conditionDescription
                      }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (
            fieldSet.includes(
              ServiceDataFields.CardiovascularConditionsInFamilyHistory
            )
          ) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.familyCardiovascularConditionsHistory'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (
                    patientHistory?.cardiovascularConditionsInFamily.hasHistory
                  ) {
                    <ng-container *ngTemplateOutlet="yesChoice" />
                  } @else {
                    <ng-container *ngTemplateOutlet="noChoice" />
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (
                  patientHistory?.cardiovascularConditionsInFamily.hasHistory
                ) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.cardiovascularConditionsInFamily
                          ?.diseases[0].conditionDescription
                      }}<br />
                      {{
                        'pdfRequestForm.common.relationToPatient' | translate
                      }}
                      {{
                        patientHistory?.cardiovascularConditionsInFamily
                          ?.diseases[0].relationToPatient
                      }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
        @if (
          serviceData.serviceInformation.shared?.patientHistory;
          as patientHistory
        ) {
          <!-- Shared by Galleri and NEG Single Carrier -->
          @if (fieldSet.includes(ServiceDataFields.BoneMarrowTransplant)) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{ 'pdfRequestForm.fields.boneMarrowTransplant' | translate }}
              </div>
              <div class="report-form-value">
                @if (patientHistory.boneMarrowTransplant?.hasReceived) {
                  <ng-container *ngTemplateOutlet="yesChoice" />
                } @else {
                  <ng-container *ngTemplateOutlet="noChoice" />
                }
              </div>
            </div>
          }
          @if (fieldSet.includes(ServiceDataFields.ParaAndGravida)) {
            <div class="report-form-row">
              <div class="report-form-inner-left-column">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.numberOfPregnancies' | translate }}
                </div>
                <div class="report-form-value">
                  {{ patientHistory?.numberOfPregnancies }}
                </div>
              </div>
              <div class="report-form-inner-right-column">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.numberOfBirths' | translate }}
                </div>
                <div class="report-form-value">
                  {{ patientHistory?.numberOfBirths }}
                </div>
              </div>
            </div>
          }
          @if (
            fieldSet.includes(
              ServiceDataFields.PreviousPregnanciesGeneticCondition
            )
          ) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.previousPregnanciesGeneticCondition'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.pregnancyDiseaseHistory?.hasHistory) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.pregnancyDiseaseHistory?.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.pregnancyDiseaseHistory?.diseases[0]
                          .conditionDescription
                      }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (
            fieldSet.includes(ServiceDataFields.FamilyHistoryOfGeneticDiseases)
          ) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.familyHistoryOfGeneticDisease'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.familyDiseaseHistory.hasHistory) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.familyDiseaseHistory.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.familyDiseaseHistory?.diseases[0]
                          .conditionDescription
                      }}<br />
                      {{
                        'pdfRequestForm.common.relationToPatient' | translate
                      }}
                      {{
                        patientHistory?.familyDiseaseHistory?.diseases[0]
                          .relationToPatient
                      }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (
            fieldSet.includes(ServiceDataFields.CarrierOfGeneticCondition) &&
            patientHistory?.carrierOfGeneticDiseases?.hasHistory !== null &&
            patientHistory?.carrierOfGeneticDiseases?.hasHistory !== undefined
          ) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.carrierOfGeneticCondition'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.carrierOfGeneticDiseases?.hasHistory) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-row">
                @if (patientHistory?.carrierOfGeneticDiseases?.hasHistory) {
                  <div class="report-form-inner-col-8">
                    <div class="report-form-row text-start">
                      {{
                        patientHistory?.carrierOfGeneticDiseases?.diseases[0]
                          .conditionDescription
                      }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (
            fieldSet.includes(
              ServiceDataFields.ChromosomalAbnormalityCarrier
            ) &&
            patientHistory?.chromosomalAbnormalityCarrier?.isCarrier !== null &&
            patientHistory?.chromosomalAbnormalityCarrier?.isCarrier !==
              undefined
          ) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.chromosomalAbnormalityCarrier'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (
                    patientHistory?.chromosomalAbnormalityCarrier?.isCarrier
                  ) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
            </div>
          }

          @if (
            fieldSet.includes(ServiceDataFields.MonogenicDisorderCarrier) &&
            patientHistory?.monogenicDisorderCarrier?.isCarrier !== null &&
            patientHistory?.monogenicDisorderCarrier?.isCarrier !== undefined
          ) {
            <div class="report-form-row">
              <div class="report-form-full-column-inner">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.monogenicDisorderCarrier' | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.monogenicDisorderCarrier?.isCarrier) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
            </div>
          }

          @if (fieldSet.includes(ServiceDataFields.HistoryOfCancer)) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{ 'pdfRequestForm.fields.historyOfCancer' | translate }}
              </div>
              <div class="report-form-value">
                @if (!patientHistory?.cancerHistory?.hasHistory) {
                  {{ 'pdfRequestForm.common.no' | translate }}
                }
                @if (patientHistory?.cancerHistory?.hasHistory) {
                  {{ 'pdfRequestForm.common.yes' | translate }},
                  {{ patientHistory?.cancerHistory?.status }}
                }
              </div>
            </div>
          }

          @if (fieldSet.includes(ServiceDataFields.HumanSerumAlbuminTherapy)) {
            <div class="report-form-row">
              <div class="report-form-inner-left-column">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.humanSerumAlbuminTherapy' | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.albuminTherapy?.hasReceived) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-inner-right-column">
                @switch (patientHistory?.albuminTherapy?.hasReceived) {
                  @case (true) {
                    <div class="report-form-key">
                      {{
                        'pdfRequestForm.fields.moreThanFourWeeksSinceLastDose'
                          | translate
                      }}
                    </div>
                    @if (!patientHistory?.albuminTherapy?.isRelevant) {
                      {{ 'pdfRequestForm.common.yes' | translate }}
                    } @else {
                      {{ 'pdfRequestForm.common.no' | translate }}
                    }
                  }
                  @default {
                    <div class="report-form-row">
                      <div class="report-form-key">&nbsp;</div>
                      <div class="report-form-value">&nbsp;</div>
                    </div>
                  }
                }
              </div>
            </div>
          }

          @if (fieldSet.includes(ServiceDataFields.CellularImmunotherapy)) {
            <div class="report-form-row">
              <div class="report-form-inner-left-column">
                <div class="report-form-key">
                  {{
                    'pdfRequestForm.fields.cellularImmunotherapyWithExogenousDna'
                      | translate
                  }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.cellularImmunotherapy?.hasReceived) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-inner-right-column">
                @switch (patientHistory?.cellularImmunotherapy?.hasReceived) {
                  @case (true) {
                    <div class="report-form-key">
                      {{
                        'pdfRequestForm.fields.moreThanFourWeeksSinceLastDose'
                          | translate
                      }}
                    </div>
                    @if (!patientHistory?.cellularImmunotherapy?.isRelevant) {
                      {{ 'pdfRequestForm.common.yes' | translate }}
                    } @else {
                      {{ 'pdfRequestForm.common.no' | translate }}
                    }
                  }
                  @default {
                    <div class="report-form-row">
                      <div class="report-form-key">&nbsp;</div>
                      <div class="report-form-value">&nbsp;</div>
                    </div>
                  }
                }
              </div>
            </div>
          }

          @if (fieldSet.includes(ServiceDataFields.StemCellTherapy)) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{ 'pdfRequestForm.fields.stemCellTherapy' | translate }}
              </div>
              <div class="report-form-value">
                @if (patientHistory?.stemCellTherapy?.hasReceived) {
                  {{ 'pdfRequestForm.common.yes' | translate }}
                } @else {
                  {{ 'pdfRequestForm.common.no' | translate }}
                }
              </div>
            </div>
          }

          @if (fieldSet.includes(ServiceDataFields.TransplantSurgery)) {
            <div class="report-form-row">
              <div class="report-form-key">
                {{ 'pdfRequestForm.fields.transplantSurgery' | translate }}
              </div>
              <div class="report-form-value">
                @if (patientHistory?.transplantSurgery?.hasReceived) {
                  {{ 'pdfRequestForm.common.yes' | translate }}
                } @else {
                  {{ 'pdfRequestForm.common.no' | translate }}
                }
              </div>
            </div>
          }

          @if (fieldSet.includes(ServiceDataFields.BloodTransfusion)) {
            <div class="report-form-row">
              <div class="report-form-inner-left-column">
                <div class="report-form-key">
                  {{ 'pdfRequestForm.fields.bloodTransfusion' | translate }}
                </div>
                <div class="report-form-value">
                  @if (patientHistory?.bloodTransfusion?.hasReceived) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
              <div class="report-form-inner-right-column">
                @switch (patientHistory?.bloodTransfusion?.hasReceived) {
                  @case (true) {
                    <div class="report-form-row">
                      <div class="report-form-key">
                        {{
                          'pdfRequestForm.fields.moreThanOneYearSinceTransfusion'
                            | translate
                        }}
                      </div>
                      <div class="report-form-value">
                        &nbsp;
                        @if (!patientHistory?.bloodTransfusion?.isRelevant) {
                          {{ 'pdfRequestForm.common.yes' | translate }}
                        } @else {
                          {{ 'pdfRequestForm.common.no' | translate }}
                        }
                      </div>
                    </div>
                  }
                  @default {
                    <div class="report-form-row">
                      <div class="report-form-key">&nbsp;</div>
                      <div class="report-form-value">&nbsp;</div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
        <div style="clear: both"></div>
      </div>
    </div>
  }

  <div class="report-form-full-column">
    <div class="report-form-header">
      {{ chapterTitles['sampling'] }}
    </div>
    <div class="report-form-region">
      <div class="report-form-inner-left-column">
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.doctorName' | translate }}
          </div>
          <div class="report-form-value">{{ pii?.sample?.doctor?.name }}</div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.dateOfBloodDraw' | translate }}
          </div>
          <div class="report-form-value">
            {{
              moment(pii?.sample?.dateOfVenipuncture).format(
                MOMENT_DATE_TIME_FORMAT_SLASH
              )
            }}
          </div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.serviceType' | translate }}
          </div>
          <div class="report-form-value">
            {{ pii?.product?.internalName }}
          </div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.repeatedSample' | translate }}
          </div>
          <div class="report-form-value">
            @if (previousSampleKitId) {
              {{ 'pdfRequestForm.common.yes' | translate }}
            } @else {
              {{ 'pdfRequestForm.common.no' | translate }}
            }
          </div>
        </div>
        @if (previousSampleKitId) {
          <div class="report-form-row">
            <div class="report-form-key">
              {{ 'pdfRequestForm.fields.repetitionOf' | translate }}
            </div>
            <div class="report-form-value">
              {{ previousSampleKitId }}
            </div>
          </div>
        }
        <div class="report-form-row">
          <div class="report-form-key">
            {{ 'pdfRequestForm.fields.dhlWaybillNumber' | translate }}
          </div>
          <div class="report-form-value">
            {{ pii?.sample?.shippingInformation?.waybill }}
          </div>
        </div>
        @if (sampleFieldSet.includes(SampleFields.SampleType)) {
          <div class="report-form-row">
            <div class="report-form-key">
              {{ 'pdfRequestForm.fields.sampleType' | translate }}
            </div>
            <div class="report-form-value">
              {{ sample?.serviceInformation?.shared?.sampleType }}
            </div>
          </div>
        }
      </div>
      <div class="report-form-inner-right-column">
        <div class="report-form-row">
          <div class="report-form-key">&nbsp;</div>
          <div class="report-form-value">&nbsp;</div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">&nbsp;</div>
          <div class="report-form-value">&nbsp;</div>
        </div>
        <div class="report-form-row">
          @switch (
            (fieldSet.includes(ServiceDataFields.IncidentalFindings) ||
              fieldSet.includes(
                ServiceDataFields.MonogenicIncidentalFindings
              )) &&
            pii?.product?.incidentalFindingsReporting !==
              IncidentalFindingsReporting.Never
          ) {
            @case (true) {
              <div class="report-form-row">
                <div class="report-form-key">
                  {{
                    fieldSet.includes(ServiceDataFields.IncidentalFindings)
                      ? ('pdfRequestForm.fields.chromosomalIncidentalFindings'
                        | translate)
                      : ('pdfRequestForm.fields.monogenicIncidentalFindings'
                        | translate)
                  }}
                </div>
                <div class="report-form-value">
                  @if (
                    serviceData?.serviceInformation?.nipt?.incidentalFindings ||
                    $any(serviceData?.serviceInformation?.mono)
                      ?.monogenicIncidentalFindings
                  ) {
                    {{ 'pdfRequestForm.common.yes' | translate }}
                  } @else {
                    {{ 'pdfRequestForm.common.no' | translate }}
                  }
                </div>
              </div>
            }
            @default {
              <div class="report-form-row">
                <div class="report-form-key">&nbsp;</div>
                <div class="report-form-value">&nbsp;</div>
              </div>
            }
          }
          <!-- incidental findings-->
        </div>
        <div class="report-form-row">
          <div class="report-form-key">&nbsp;</div>
          <div class="report-form-value">&nbsp;</div>
        </div>
        <div class="report-form-row">
          <div class="report-form-key">&nbsp;</div>
          <div class="report-form-value">&nbsp;</div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>

  @if (fieldSet.includes(ServiceDataFields.GenderInformation)) {
    <div class="report-form-full-column">
      <div class="report-form-header">
        {{ chapterTitles['genderIdentification'] }}
      </div>
      <div class="report-form-region">
        <div class="report-form-inner-left-column">
          <div class="report-form-row">
            <div class="report-form-key">
              {{ 'pdfRequestForm.fields.genderIdentification' | translate }}
            </div>
            <div class="report-form-value">
              <ng-container *ngTemplateOutlet="yesChoice"></ng-container>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  }

  @if (
    this.serviceDataUtilsService.getPropertyFromServiceInformation(
      serviceData?.serviceInformation,
      'comments'
    )
  ) {
    <div class="report-form-full-column">
      <div class="report-form-header">
        {{ chapterTitles['comments'] }}
      </div>
      <div class="report-form-region">
        <div class="report-form-inner-left-column">
          <div class="report-form-row">
            <div>
              {{
                this.serviceDataUtilsService.getPropertyFromServiceInformation(
                  serviceData?.serviceInformation,
                  'comments'
                )
              }}
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  }
</div>

<ng-template #yesChoice>
  {{ 'pdfRequestForm.common.yes' | translate }}
</ng-template>
<ng-template #noChoice>
  {{ 'pdfRequestForm.common.no' | translate }}
</ng-template>

<ng-template #noRecords>
  <div class="report-form-inner-col-12">
    <div class="report-form-row text-center">
      {{ 'pdfRequestForm.common.empty' | translate }}
    </div>
  </div>
</ng-template>
